import React, {useEffect, useState} from 'react';
import {Col, Input, PageHeader, Row} from 'antd';
import {getD365RateCodes} from '../../api/d365Api';
import {SearchOutlined} from '@ant-design/icons';
import _ from 'lodash';
import {RatesTable} from "./RatesTable";
import {getPaginationConfig} from "../../util/showAllPagination";

const Rates = () => {
  const [rates, setRates] = useState([]);
  const [exports, setExports] = useState([]);
  const [filteredRates, setFilteredRates] = useState([]);
  const [loading, setLoading] = useState(false);

  const filterRates = (rates, searchText) => {
    const lcSearchText = _.toLower(searchText)
    setFilteredRates(
      _.chain(rates)
        .filter(
          (u) =>
            searchText === "" ||
            _.includes(_.toLower(u.projectCode), lcSearchText)
        )
        .value()
    );
  };

  const search = (text) => {
    filterRates(rates, text);
  };

  const load = async () => {
    try {
      setLoading(true);
      const response = await getD365RateCodes();
      setRates(response.rates);
      setExports(response.exports);
      setFilteredRates(response.rates);
    } catch (e) {
      console.error(`Could not get rate codes`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <>
      <Row>
        <Col span={12}>
          <PageHeader
            title="D365 Rates"
            subTitle={`(${filteredRates ? filteredRates.length : 0} shown)`}
            style={{padding: 0}}
          />
        </Col>
      </Row>
      <Row style={{marginBottom: 10}}>
        <Col span={12} style={{marginRight: 10}}>
          <Input
            style={{maxWidth: 400}}
            placeholder="Search for rates by Project Code"
            prefix={<SearchOutlined/>}
            onChange={(e) => search(e.target.value)}
            allowClear
          />
        </Col>
      </Row>
      <RatesTable
        rates={filteredRates}
        exports={exports}
        loading={loading}
        pagination={getPaginationConfig(filteredRates.length)}
      />
    </>
  );
};

export {Rates};